import { FC, useState } from 'react';
import cn from 'classnames';
import Icon from '@components/Icon/Icon';
import { IconArrowBottom } from '@icons';
import { makeEnding } from '@core/old_helpers';

export type GrowthPeriodHeaderProps = {
    years: number[];
    selectedPeriod: number;
    onPeriodChange: (years: number) => void;
};

function getGrowthPeriodLabel(yearsCount: number): string {
    if (yearsCount === 1) return '12 months';
    return `${yearsCount} ${makeEnding('year', yearsCount)}`;
}

const GrowthPeriodHeader: FC<GrowthPeriodHeaderProps> = ({
        years,
        selectedPeriod,
        onPeriodChange,
    }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleDropdownClick = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleYearClick = (year: number) => {
        onPeriodChange(year);
        setIsDropdownOpen(false);
    };

    return (
        <div className="GrowthPeriodHeader">
            <div
                className="GrowthPeriodHeader__trigger"
                onClick={handleDropdownClick}
            >
                <div className="GrowthPeriodHeader__label">
                    <span>{getGrowthPeriodLabel(selectedPeriod)}</span>
                    <span
                        className={cn(
                            'GrowthPeriodHeader__icon',
                            isDropdownOpen && 'GrowthPeriodHeader__icon--opened',
                        )}
                    >
                        <Icon type="small">
                            <IconArrowBottom/>
                        </Icon>
                    </span>
                </div>
            </div>
            {isDropdownOpen && (
                <div className="GrowthPeriodHeader__dropdown">
                    {years.filter(year => year !== selectedPeriod).map(year => (
                        <div
                            key={year}
                            className="GrowthPeriodHeader__dropdown-item"
                            onClick={() => handleYearClick(year)}
                        >
                            {getGrowthPeriodLabel(year)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GrowthPeriodHeader;
